var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['file-message-container'],
    attrs: {
      "title": _vm.TUITranslateService.t('TUIChat.单击下载')
    },
    on: {
      "click": _vm.download
    }
  }, [_c('Icon', {
    staticClass: "file-icon",
    attrs: {
      "file": _vm.files
    }
  }), _c('div', [_c('div', [_vm._v(_vm._s(_vm.props.content.name))]), _c('div', [_vm._v(_vm._s(_vm.props.content.size))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }